import { CourseOfStudyDto } from '@cradua/data';
import { createReducer, on, Action } from '@ngrx/store';
import { EntityState, EntityAdapter, createEntityAdapter } from '@ngrx/entity';

import * as CourseOfStudyActions from './courseofstudy.actions';

export const COURSE_OF_STUDY_FEATURE_KEY = 'courseofstudy';

export interface CourseOfStudyState extends EntityState<CourseOfStudyDto> {
  selectedCourseOfStudyId?: string | number; // which CourseOfStudy record has been selected
  loaded: boolean; // has the CourseOfStudy list been loaded
  error?: string | null; // last none error (if any)
}

export interface CourseOfStudyPartialState {
  readonly [COURSE_OF_STUDY_FEATURE_KEY]: CourseOfStudyState;
}

export const courseofstudyAdapter: EntityAdapter<CourseOfStudyDto> = createEntityAdapter<
  CourseOfStudyDto
>({
  selectId: (courseofstudy) => courseofstudy.id,
  sortComparer: false,
});

export const initialState: CourseOfStudyState = courseofstudyAdapter.getInitialState(
  {
    // set initial required properties
    loaded: false,
    error: null,
    selectedCourseOfStudyId: null,
  }
);

const courseofstudyReducer = createReducer(
  initialState,
  on(CourseOfStudyActions.loadCourseOfStudy, (state) => ({
    ...state,
    loaded: true,
    error: null,
  })),
  on(
    CourseOfStudyActions.loadCourseOfStudySuccess,
    (state, { courseofstudy }) =>
      courseofstudyAdapter.addAll(courseofstudy, { ...state, loaded: false })
  ),
  on(CourseOfStudyActions.loadCourseOfStudyFailure, (state, { error }) => ({
    ...state,
    loaded: false,
    error,
  })),
  on(CourseOfStudyActions.addCourseOfStudy, (state) => ({
    ...state,
    loaded: true,
    error: null,
  })),
  on(
    CourseOfStudyActions.addCourseOfStudySuccess,
    (state, { newCourseOfStudy }) =>
      courseofstudyAdapter.addMany(newCourseOfStudy, {
        ...state,
        loaded: false,
      })
  ),
  on(CourseOfStudyActions.addCourseOfStudyFailure, (state, { error }) => ({
    ...state,
    loaded: false,
    error,
  })),
  on(CourseOfStudyActions.updateCourseOfStudy, (state) => ({
    ...state,
    loaded: true,
    error: null,
  })),
  on(
    CourseOfStudyActions.updateCourseOfStudySuccess,
    (state, { updateCourseOfStudy }) =>
      courseofstudyAdapter.upsertMany(updateCourseOfStudy, {
        ...state,
        loaded: false,
      })
  ),
  on(CourseOfStudyActions.updateCourseOfStudyFailure, (state, { error }) => ({
    ...state,
    loaded: false,
    error,
  })),
  on(CourseOfStudyActions.removeCourseOfStudy, (state) => ({
    ...state,
    loaded: true,
    error: null,
  })),
  on(CourseOfStudyActions.removeCourseOfStudySuccess, (state, { ids }) =>
    courseofstudyAdapter.removeMany(ids, { ...state, loaded: false })
  ),
  on(CourseOfStudyActions.removeCourseOfStudyFailure, (state, { error }) => ({
    ...state,
    loaded: false,
    error,
  }))
);

export function reducer(state: CourseOfStudyState | undefined, action: Action) {
  return courseofstudyReducer(state, action);
}
